import {PureComponent} from 'react'
import {Link} from 'react-router-dom'
import PropTypes from 'prop-types'

import {generate} from '../../../../routes.js'

import './Tags.scss'

export default class Tags extends PureComponent {
  static propTypes = {
    className: PropTypes.string,
    tags: PropTypes.array
  }

  static defaultProps = {
    className: '',
    tags: []
  }

  generateLink = (slug) => {
    return generate({
      name: 'blog-tag',
      parameters: {
        slug: slug
      }
    })
  }

  render() {
    return (
      <div className={`tags-list ${this.props.className}`}>
        <h3>Tags</h3>
        <ul>
          {this.props.tags.map((tag) => (
            <li key={tag.slug}>
              <Link to={this.generateLink(tag.slug)}>{tag.name}</Link>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}
